module.exports = __webpack_public_path__ + "img/01.363cda8c.jpg";